import Vue from 'vue'
import Vuex from 'vuex'
import user_store from './modules/user';
import catalog from "./modules/catalog";
import inbox_state from "./modules/inbox_state";
import orders from "./modules/orders";
import dashboard from "./modules/dashboard";
import shiporder from "./modules/shiporder";
import modifiers from "./modules/modifiers";
import stop from "./modules/stop";
import common from "./modules/common";
import pos from "./modules/pos";
import agregators from "./modules/agregators";
import deliveries from "./modules/deliveries";
import choose_groups from "./modules/choose_groups";
import actions from "./modules/actions";
import news from "./modules/news";

Vue.use(Vuex);



export default new Vuex.Store({
    modules: {
        pos : pos,
        aggregator : agregators,
        common: common,
        user    : user_store,
       // orders : orders,

      //  modifiers : modifiers,
      //  shiporder : shiporder,

        catalog : catalog,
        inbox_state : inbox_state,

        dashboard : dashboard,
        stop : stop,

        deliveries : deliveries,
        groups : choose_groups,
        actions : actions,
        news : news,

    },
})
